__turbopack_context__.v({
  "footer": "menuItem-module-scss-module__QSpO4G__footer",
  "inverted": "menuItem-module-scss-module__QSpO4G__inverted",
  "listItem": "menuItem-module-scss-module__QSpO4G__listItem",
  "menu": "menuItem-module-scss-module__QSpO4G__menu",
  "menuItem": "menuItem-module-scss-module__QSpO4G__menuItem",
  "navigation": "menuItem-module-scss-module__QSpO4G__navigation",
  "neutral": "menuItem-module-scss-module__QSpO4G__neutral",
});
